import React, { useEffect, useRef, useState } from "react";
import * as d3 from "d3";
import { nest } from "d3-collection";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";

const MariMekkoChart = ({ chartData }) => {
  const [widthHeight] = useState({
    width: "830",
    height: "200",
  });

  const svgRef = useRef(null);
  useEffect(() => {
    const numberValue = (value) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    };
    const data = [
      { market: "Graduate", segment: "Male", value: numberValue(chartData?.male_graduate) },
      { market: "Graduate", segment: "Female", value: numberValue(chartData?.female_graduate) },
      { market: "Completed School", segment: "Male", value: numberValue(chartData?.male_complete_schooling) },
      {
        market: "Completed School",
        segment: "Female",
        value: numberValue(chartData?.female_complete_schooling),
      },
      { market: "Basic Literacy", segment: "Male", value: numberValue(chartData?.male_basic_literacy) },
      { market: "Basic Literacy", segment: "Female", value: numberValue(chartData?.female_basic_literacy) },
      { market: "Illiterate", segment: "Male", value: numberValue(chartData?.male_illiterate) },
      { market: "Illiterate", segment: "Female", value: numberValue(chartData?.female_illiterate) },
    ];

    const totalMArr = data.filter((obj) => {
      return obj.segment === "Male";
    });
    let sumM = 0;
    const totalM = totalMArr.map((item) => {
      sumM += item.value;
    });
    const totalFArr = data.filter((obj) => {
      return obj.segment === "Female";
    });
    let sumF = 0;
    const totalF = totalFArr.map((item) => {
      sumF += item.value;
    });

    var width = widthHeight.width;
    var height = widthHeight.height;
    const margin = 60;
    const p = d3.format("%");
    const x = d3.scaleLinear().range([0, width - 3 * margin]);
    const y = d3.scaleLinear().range([0, height - 2 * margin]);
    var z = d3
      .scaleOrdinal()
      .domain(["Illiterate", "Basic Literacy", "Completed School", "Graduate"])
      .range(["#C87050", "#F79842", "#EBC825", "#85C500"]);

    // Remove existing chart content if it exists
    d3.select(svgRef.current).select("svg").remove();

    // Append new SVG for the chart
    const svg = d3
      .select(svgRef.current)
      .append("svg")
      .attr("width", width)
      .attr("height", height)
      .append("g")
      .attr("transform", "translate(" + margin + "," + margin + ")");

    const segments = nest()
      .key(function (d) {
        return d.segment;
      })
      .entries(data);

    const sum = segments.reduce((v, p) => {
      return (
        (p.offset = v) +
        (p.sum = p.values.reduceRight((v, d) => {
          d.parent = p;
          return (d.offset = v) + d.value;
        }, 0))
      );
    }, 0);
    const safeSum = sum || 1;

    const segmentsGroup = svg
      .selectAll(".segment")
      .data(segments)
      .enter()
      .append("g")
      .attr("class", "segment")
      .attr("transform", function (d) {
        return "translate(0," + y(d.offset / safeSum) + ")";
      });

    const markets = segmentsGroup
      .selectAll(".market")
      .data(function (d) {
        return d.values;
      })
      .enter()
      .append("a")
      .attr("class", "market")
      .attr("xlink:title", function (d) {
        return d.market + " " + d.parent.key + ": " + parseInt(p(d.value / 100)) + "%";
      })
      .append("rect")
      .attr("x", function (d) {
        return x(d.parent.sum ? d.offset / d.parent.sum : 0);
      })
      .attr("width", function (d) {
        return x(d.parent.sum ? d.value / d.parent.sum : 0);
      })
      .attr("height", function (d) {
        return y(d.parent.sum / safeSum);
      })
      .style("fill", function (d) {
        return z(d.market);
      });
    const mLabel = svg
      .append("text")
      .text("MALE")
      .attr("x", -(margin / 2 + 20))
      .attr("y", 20)
      .style("font-size", "10px")
      .style("fill", "#1a1a1a");
    const mValue = svg
      .append("text")
      // .text(((sumM / (sumF + sumM)) * 100).toFixed(1) + "hyhhy%")
      .text(numberValue(chartData?.male_ratio) + "%")

      .attr("x", -(margin / 2 + 10))
      .attr("y", 35)
      .style("font-size", "10px")
      .style("fill", "#1a1a1a");

    const fLabel = svg
      .append("text")
      .text("FEMALE")
      .attr("x", -(margin / 2 + 20))
      .attr("y", 60)
      .style("font-size", "10px")
      .style("fill", "#1a1a1a");

    const fValue = svg
      .append("text")
      .text(numberValue(chartData?.female_ratio) + "%")
      .attr("x", -(margin / 2 + 10))
      .attr("y", 75)
      .style("font-size", "10px")
      .style("fill", "#1a1a1a");

    var gridX = d3.range(6).map(function (i) {
      return { x1: 0, y1: 0, x2: 0, y2: height - 2 * margin };
    });

    // draw grid
    svg
      .append("g")
      .attr("id", "grid")
      .attr("transform", "translate(0,0)")
      .selectAll("line")
      .data(gridX)
      .enter()
      .append("line")
      .attr("x1", function (d, i) {
        return i * ((width - margin * 3) / 5);
      })
      .attr("y1", function (d) {
        return d.y1;
      })
      .attr("x2", function (d, i) {
        return i * ((width - margin * 3) / 5);
      })
      .attr("y2", function (d) {
        return d.y2;
      })

      .style("stroke", "#e5e5e5")
      .style("stroke-width", "1px");

    var title = svg
      .append("text")
      .text("EDUCATION LEVEL")
      .attr("x", -(margin / 2 + 20))
      .attr("y", -30)
      .style("font-size", "10px")
      .style("font-weight", "bold")
      .style("font-family", "sans-serif")
      .style("fill", "#1a1a1a");

    var legendOffset = 40;
    var legendRectSize = 12;
    var legendSpacing = 95;
    var legendWidth = legendRectSize + legendSpacing;

    var legend = svg
      .selectAll(".legend")
      .data(z.domain())

      .enter()
      .append("g")
      .attr("class", "legend")
      .attr("transform", function (d, i) {
        if (i === 0) return "translate(" + (i * legendWidth + 80) + ", -40)";
        else if (i === 1) return "translate(" + (i * legendWidth + 40) + ", -40)";
        else return "translate(" + (i * legendWidth + 20) + ", -40)";
      });

    legend
      .append("rect")
      .attr("width", legendRectSize)
      .attr("height", legendRectSize)
      .attr("rx", 20)
      .attr("ry", 20)

      .style("fill", function (d, i) {
        return z(d);
      });

    legend
      .append("text")
      .attr("x", 15)
      .attr("y", 8)
      .text(function (d) {
        return d;
      })
      .style("color", "#000000")
      .style("font-family", "sans-serif")
      .style("font-size", "9px");

    const percentages = [0, 20, 40, 60, 80, 100];

    svg
      .selectAll(".percentage")
      .data(percentages)
      .enter()
      .append("text")
      .attr("class", "percentage")
      .attr("x", function (d, i) {
        return i * ((width - margin * 3) / 5);
      })
      .attr("y", 95)
      .text(function (d) {
        return d + "%";
      })
      .style("font-size", "10px")
      .style("fill", "#1a1a1a")
      .attr("text-anchor", "middle");
  }, [widthHeight, chartData]);

  return <div ref={svgRef}></div>;
};

export default MariMekkoChart;
